import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useAuth0 } from '@auth0/auth0-react';
import i18next from 'i18next';
import { useAuthFetchFromRestAPI } from '../../../util/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import EmptyState from '../../../components/EmptyState';
import AppointmentList from '../../../components/appointment/AppointmentList';
import { AppointmentDto } from '../../../../../shared/dtos/appointment.dto';

const AppointmentsPage: FC = (): ReactElement => {
  const { user } = useAuth0();
  const { authFetch } = useAuthFetchFromRestAPI();

  const [appointments, setAppointments] = useState<AppointmentDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!user) {
      return;
    }

    const run = async (): Promise<void> => {
      try {
        const appointmentFromRemote: AppointmentDto[] = await authFetch('/api/v1/appointment/therapist');
        setAppointments(appointmentFromRemote);
      } catch (error) {
        console.error('Error occured while fetching appointments', error);
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    void run();
  }, [user]);

  return (
    <Container className="py-4">
      <div
        className="d-flex align-items-center gap-3 px-4 py-3 text-white rounded-3 mb-3"
        style={{ backgroundColor: '#234a68' }}
      >
        <i className="fas fa-calendar-alt fs-4" aria-hidden="true" />
        <span className="fw-semibold fs-4 text-truncate">{i18next.t('header.appointments')}</span>
      </div>

      <div className="bg-white border rounded-3 shadow-sm p-4">
        {isLoading ? (
          <LoadingSpinner />
        ) : hasError ? (
          <Alert variant="danger" className="mb-0">
            {i18next.t('generic.error')}
          </Alert>
        ) : appointments.length === 0 ? (
          <EmptyState icon="fas fa-calendar-alt" message={i18next.t('createAppointmentForm.noAppointmentData')} />
        ) : (
          <AppointmentList appointments={appointments} />
        )}
      </div>
    </Container>
  );
};

export default AppointmentsPage;
